import { type CSSProperties, type ElementType, type ReactNode } from "react";

import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/cn";

const APPEAR_TRIGGER = { once: true, rootMargin: "0px 0px -12% 0px" };

interface AppearProps {
  as?: ElementType;
  className?: string;
  delay?: number;
  children: ReactNode;
}

export const Appear = ({ as: Tag = "div", className, delay = 0, children }: AppearProps) => {
  const [ref, inView] = useInView<HTMLElement>(APPEAR_TRIGGER);

  return (
    <Tag
      ref={ref}
      className={cn("landing-appear", className)}
      data-revealed={inView ? "" : undefined}
      style={delay ? ({ "--appear-delay": `${delay}ms` } as CSSProperties) : undefined}
    >
      {children}
    </Tag>
  );
};
